//Todo: will remove the entire file later, after new one is done

import React, {
  Fragment,
  useCallback,
  useRef,
  useEffect,
  useMemo,
  useState
} from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Column, Grid, Row } from '@lux/components';
import { getUrlParams, noop, setUrlParams } from '@lux/helpers';

import CartSummary from '../../components/CartSummary';
import CisPointOfEntry from '../../components/CisPointOfEntry';
import ExclusiveValidation from '../../components/ExclusiveValidation';
import PhoneDetails from '../../components/PhoneDetails';
import PhoneDetailsInfo from '../../components/PhoneDetailsInfo';
import PhoneDetailsPlanSelect from '../../components/PhoneDetailsPlanSelect';
import PhoneDetailsVideo from '../../components/PhoneDetailsVideo';
import PhoneMonthSelection from '../../components/PhoneMonthSelection';
import PlansList from '../../components/PlansList';
import SEO from '../../components/SEO';
import Spacing from '../../components/Spacing';
import TransactionDialog from '../../components/TransactionDialog';
import Notification from '../../components/Notification';
import PersistStatusConsumer from '../../components/PersistStatusConsumer';

import {
  authActions,
  planActions,
  productActions,
  rootActions
} from '@detox/actions';

import findPlanGroupByName from '../../helpers/findPlanGroupByName';
import flattenNodes from '../../helpers/flatten-nodes';
import formatPrice from '../../helpers/formatPrice';
import getAemComponentByName from '../../helpers/getAemComponentByName';
import isValidYoutubeLink from '../../helpers/isValidYoutubeLink';
import isTagged from '../../helpers/isTagged';
import { phoneTagsConfig } from '../../config/phone-config';

import useStockAvailability from '../../hooks/useStockAvailability';

import '../../fragments/phone-detail';
import '../../fragments/plan-detail';
import '../../fragments/aem-components';

import {
  getAllSizes,
  getCisPlanGroups,
  getColoursAndSizesToRender,
  getPlansWithCisPrices,
  getProduct,
  getSectionTestId,
  PhoneImages
} from './helpers';
import Button from '../../components/Button';
import slugify from '../../helpers/slugify';
import useMounted from '../../hooks/useMounted';
import { navigateToSpringDPlans } from '../../helpers/navigation';
import { cisGOMOPortInEntryUrl } from '../../config/links';
import { useBrowserBack } from '../../hooks/useBrowserBack/useBrowserBack';
import isSimOnlyPlan from '../../helpers/is-sim-only-plan';
import { constructProductUrl } from '../../helpers/catalogue-helpers';
import { Text } from '@dls/web';

const colourClassName = 'colorSelection';
const sizeClassName = 'sizeSelection';
const planNameClassName = 'planNameSelection';
const monthlyTermClassName = 'monthlyTermSelection';

export const OldPhoneDetails = ({
  data,
  exclusiveValidation,
  location,
  getAuthToken,
  setSelectedProduct,
  setSelectedPlan,
  setUserSelection,
  selectedProduct,
  selectedPlan,
  sessionToken,
  resetByKeys,
  cisPlanRates,
  auth,
  hideExclusiveValidation,
  resetWorryFree
}) => {
  const {
    skuVariants,
    title,
    colours,
    imageGallery,
    videoUrl,
    description,
    shippingLiner,
    freeGiftsByDevice,
    freeGiftsBySku,
    promotions,
    groupId,
    whatsInTheBox,
    specifications,
    slug,
    tags = []
  } = data.phone;

  const {
    siteMetadata: { siteUrl }
  } = data.site;

  const isMounted = useMounted();
  const isCIS = Boolean(cisPlanRates);
  useBrowserBack();
  useEffect(() => {
    resetByKeys(['user']);
  }, [resetByKeys]);

  useEffect(() => {
    setUserSelection({ plan: selectedPlan });
  }, [selectedPlan]);

  // Get Auth Token component first renders
  useEffect(() => {
    const cleanWorryFree = auth.worryFree.otpVerified;

    if (!sessionToken || cleanWorryFree) {
      // We get token only when there is no session token,
      // or when user has logged in via WF before and needs cleaning
      getAuthToken({ cleanWorryFree });
    } else if (sessionToken && auth.worryFree.status) {
      // Reset worry free error statuses if any
      resetWorryFree();
    }
  }, [
    auth.worryFree.otpVerified,
    auth.worryFree.status,
    getAuthToken,
    resetWorryFree,
    sessionToken
  ]);

  let { allPlanGroup, allPlan } = data;
  allPlan = useMemo(() => {
    // Filter plans by SKU that does not exist for a particular plan
    const plans = flattenNodes(allPlan).filter(plan =>
      skuVariants.some(sku => sku.planId === plan.mecId)
    );

    //Include CIS plan rates
    if (cisPlanRates) {
      return getPlansWithCisPrices(plans, cisPlanRates);
    }

    //Regular plans if no cis
    return plans;
  }, [allPlan, skuVariants, cisPlanRates]);

  // Flatten the plan groups to its unique values and return the available plan groups for a particular phone
  allPlanGroup = useMemo(() => {
    const planGroups = flattenNodes(allPlanGroup).filter(group =>
      [...new Set(allPlan.map(plan => plan.groupName))].includes(
        group.groupName
      )
    );

    if (cisPlanRates) {
      const cisPlanGroups = planGroups.filter(group => {
        const { segment = [] } = group;
        return segment.includes('cis');
      });
      return getCisPlanGroups(cisPlanGroups, allPlan, cisPlanRates);
    } else {
      return planGroups.filter(group => {
        const { segment = [] } = group;
        return segment.includes('res');
      });
    }
  }, [allPlan, allPlanGroup, cisPlanRates]);

  const phonePromotions = cisPlanRates ? promotions.cis : promotions.res;

  const defaultPlan = allPlan.find(p => p.selected) || allPlan[0];

  const selectedPlanId = selectedPlan && selectedPlan.mecId;

  const [pageTitle, setPageTitle] = useState(title);
  const [selectedColour, setColour] = useState();
  const [selectedMonth, setMonth] = useState();
  const [selectedSize, setSize] = useState();
  const [stockErrorMsg, setStockErrorMsg] = useState('');
  const [disableSection, setDisableSection] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  const stockAvailability = useStockAvailability(
    skuVariants,
    sessionToken,
    groupId,
    true
  );

  const freeGiftStockAvail = useStockAvailability(
    freeGiftsByDevice,
    sessionToken,
    groupId
  );

  const selectedPlanGroupName =
    selectedPlan?.groupName ?? defaultPlan.groupName;

  let renderPlans = allPlan.filter(
    plan => plan.groupName === selectedPlanGroupName
  );

  let renderPlanGroups = allPlanGroup;

  // Sku selection logic
  const skusByPlan = skuVariants.filter(s => s.planId === selectedPlanId);
  const allSizes = getAllSizes(skusByPlan);

  const {
    renderColours,
    renderMonths,
    renderSizes,
    renderSizesByProduct
  } = getColoursAndSizesToRender({
    colours,
    renderPlans,
    skusByPlan,
    skuVariants,
    sizes: allSizes,
    selectedColour,
    selectedMonth,
    selectedPlanGroupName,
    selectedSize,
    stockAvailability
  });

  const showCartSummary = !!(selectedProduct && selectedPlan);

  const { allAemPages } = data;
  const siteConfigurations = getAemComponentByName(
    allAemPages,
    'SiteConfigurations'
  );

  const isGomoToSingtelEnabled =
    siteConfigurations && siteConfigurations.switches.DETOX_GOMO_TO_SINGTEL;

  useEffect(() => {
    //Include original and discounted price in store for cis plans
    if (cisPlanRates) {
      const cisRate = cisPlanRates.find(
        rate => rate.planID === selectedPlan.basePriceSchemaId
      );
      setSelectedPlan({
        ...selectedPlan,
        monthlyCharges: cisRate.discountedPrice ?? selectedPlan.monthlyCharges,
        originalPrice: selectedPlan.monthlyCharges
      });
    }
  }, [cisPlanRates]);

  useEffect(() => {
    if (isSimOnlyPlan(selectedPlan) && !selectedMonth) {
      const selected_ipp_term = location?.state?.installTerm;
      selected_ipp_term
        ? setMonth(selected_ipp_term)
        : setMonth(renderMonths[0]);
    }
  }, [renderMonths, selectedMonth]);

  // This sets the local state for colour and size, as well as plan to the store
  const setLocalProductState = useCallback(
    ({ colour, size, planId, monthlyTerm }) => {
      setColour(colour);
      setSize(size);
      setMonth(monthlyTerm);
      const plan = allPlan.find(p => p.mecId === planId);
      if (plan) {
        setSelectedPlan(plan);
      }
    },
    [allPlan, setSelectedPlan]
  );

  // This function gets the hidden product selection dom element
  // returns the colour, size and planId of the current html page
  const getProductSelectionFromDOM = useCallback(productUrl => {
    try {
      const isCIS = Boolean(cisPlanRates);

      const [element] = document.getElementsByClassName(
        !isCIS ? productUrl : `cis-${productUrl}`
      );

      const getElement = type => element.getElementsByClassName(type)[0];
      const colour = getElement(colourClassName).textContent;
      const size = getElement(sizeClassName).textContent;
      const planId = getElement(planNameClassName).textContent;
      const monthlyTerm = getElement(monthlyTermClassName)?.textContent;
      return { colour, size, planId, monthlyTerm };
    } catch (e) {
      // Cannot find product from the url, so we return empty object
      return {};
    }
  }, []);

  const getPlanNameWithId = useCallback(
    planId => {
      const matched = allPlan.find(p => p.mecId === planId);
      return matched && matched.planName;
    },
    [allPlan]
  );

  useEffect(() => {
    const didMount = isMounted() && !selectedColour && !selectedSize;

    if (didMount) {
      // user just entered the app, and we have to determine where to get the data
      // to hydrate the UI.
      const getProductUrl = path =>
        path
          .substring(`/phones/${slug}`.length, path.length)
          .replace(/\//g, '');

      const productUrl = getProductUrl(location.pathname);

      const selectedProductDataMatchPhoneData =
        selectedProduct &&
        data.phone &&
        selectedProduct.groupId == data.phone.groupId;
      const hydrateAppFromSavedSession =
        !productUrl && selectedProductDataMatchPhoneData;

      if (productUrl) {
        // user entered app using product url
        // so we set the local state with details from the url
        const productSelection = getProductSelectionFromDOM(productUrl);
        setLocalProductState(productSelection);
      } else if (hydrateAppFromSavedSession) {
        // user entered app without product url and has a selected product from before
        // so we set the local state with the one from the store
        const { colour, size, planId, monthlyTerm } = selectedProduct;
        setLocalProductState({ colour, size, planId, monthlyTerm });
      } else if (!productUrl && !selectedPlan) {
        // user entered app without product url and has no selected plan from before
        // so we set a default plan
        setSelectedPlan(defaultPlan);
      } else if (renderPlans.length === 0) {
        // selected plan is not allowed
        setSelectedPlan(defaultPlan);
      }
    }
  }, [
    defaultPlan,
    getProductSelectionFromDOM,
    location.pathname,
    selectedColour,
    selectedMonth,
    selectedPlan,
    selectedProduct,
    selectedSize,
    setLocalProductState,
    setSelectedPlan,
    slug,
    renderPlans
  ]);

  // Sets product to store whenever the colour, size, or plan selection change.

  useEffect(() => {
    const product = getProduct({
      skuVariants,
      selectedPlanId,
      selectedColour,
      selectedMonth,
      selectedSize
    });

    const updateProductUrl = url => {
      window.history.replaceState(
        null,
        null,
        setUrlParams(url, getUrlParams())
      );
    };

    if (product) {
      const { colour, size, planId, monthlyTerm } = product;

      let sameAsStore =
        product.sku === selectedProduct?.sku &&
        product.planId === selectedProduct?.planId;

      if (monthlyTerm) {
        sameAsStore =
          sameAsStore && monthlyTerm === selectedProduct?.monthlyTerm;
      }

      // We should only update store when store is undefined and a product is found now,
      // and also when the found product is different from the one in the store
      if (!selectedProduct || !sameAsStore) {
        setPageTitle(`${title} ${colour} ${size}`);

        // Adds additional information to keep in the store
        const extendedProduct = {
          ...product,
          title,
          imageGallery
        };

        setSelectedProduct(extendedProduct);
        const planName = getPlanNameWithId(planId);
        const url = constructProductUrl(colour, size, planName, monthlyTerm);
        updateProductUrl(`/phones/${slug}/${url}`);
      }
    }

    //Check stocks by size
    const isOutOfStock = renderSizes.every(size => size.available === false);
    setDisableSection(!selectedColour || isOutOfStock);

    //Error message for out of stock phones
    let errorMessage;
    if (isOutOfStock) {
      errorMessage = 'Currently out of stock';
    } else {
      errorMessage = '';
    }

    //Set error message
    setStockErrorMsg(errorMessage);

    //Preselect size on colour change, if a size is out of stock choose the first match with stocks
    const checkSize =
      renderSizes.find(size => size.available && size.name === selectedSize) ||
      renderSizes.find(size => size.available);

    if (checkSize && !isOutOfStock) {
      setSize(checkSize.size);
    }
  }, [
    getPlanNameWithId,
    imageGallery,
    selectedColour,
    selectedMonth,
    selectedPlanId,
    selectedProduct,
    selectedSize,
    setSelectedProduct,
    skuVariants,
    slug,
    stockAvailability,
    title
  ]);

  useEffect(() => {
    //Check for stocks and preselect the first matched colour with the stocks
    const preselectColour = renderColours.find(colour => colour.available);

    //Check if selectedColour has no stock
    const checkSelectedColourStock = renderColours.filter(
      colour => !colour.available && colour.name === selectedColour
    );

    //Check if all colours are out of stock
    const allOutOfStock =
      renderColours.filter(colour => !colour.available).length ===
      renderColours.length;

    //Don't update preselection
    if (allOutOfStock) {
      return;
    }

    //Preselect to closest available stocks
    if (selectedColour && checkSelectedColourStock.length > 0) {
      setColour(preselectColour?.name);
    }
  }, [stockAvailability]);

  useEffect(() => {
    if (selectedColour && selectedPlan && selectedSize) {
      window.lpTag &&
        window.lpTag.sdes.send &&
        window.lpTag.sdes.send({
          type: 'prodView',
          products: [
            {
              product: {
                name: `${title} - ${selectedColour} ${selectedSize} - ${selectedPlan.planName}`
              }
            }
          ]
        });
    }
  }, [selectedColour, selectedPlan, selectedSize, title]);

  const handleContinueButtonClick = async () => {
    setOpenModal(true);
  };

  const handleGomoPortInClick = () => {
    if (!isCIS) navigateToSpringDPlans({ groupName: selectedPlanGroupName });
    else {
      window.location.assign(cisGOMOPortInEntryUrl);
    }
  };

  // Select a plan on plan group change
  const handlePlanGroupChange = planGroup => {
    const plans = allPlan.filter(p => p.groupName === planGroup.groupName);
    let matched = plans.find(p => p.mecId === defaultPlan.mecId);

    if (planGroup.groupName === 'Sim Only Plus') {
      const simOnlyPlusGroup = findPlanGroupByName(
        allPlanGroup,
        planGroup.groupName
      );
      matched = allPlan.find(
        plan => plan.mecId === simOnlyPlusGroup.defaultPlan
      );
    }

    setMonth(undefined);
    setSelectedPlan(matched || plans[0]);
  };

  // If a plan is clicked after it is already the selected plan, prevent it from triggering additional meaningless action calls
  const onPlanChange = plan => {
    if (selectedPlan.mecId !== plan.mecId) {
      setSelectedPlan(plan);
    }
  };

  const isSimOnlyPlus = selectedPlanGroupName === 'Sim Only Plus';
  const showProductVideo = isValidYoutubeLink(videoUrl);

  const { installmentPrice, monthlyTerm, partialUpfrontAmount } =
    selectedProduct || {};

  if (selectedPlan && isSimOnlyPlan(selectedPlan)) {
    selectedPlan.selectedMonthlyTerm = selectedMonth;
  }

  const hasPlanPhoneMonthly =
    installmentPrice && monthlyTerm && partialUpfrontAmount >= 0;

  const payTodayValue = hasPlanPhoneMonthly
    ? partialUpfrontAmount
    : selectedProduct?.price;
  const payToday = formatPrice(payTodayValue);

  const monthlySubscription = hasPlanPhoneMonthly
    ? `${formatPrice(
        Number(selectedPlan?.monthlyCharges) + Number(installmentPrice)
      )}`
    : formatPrice(selectedPlan?.monthlyCharges);

  const mirodataSkuIdentifier =
    selectedProduct &&
    createMirodataSkuIdentifier(
      selectedProduct.sku,
      selectedPlan.planName,
      selectedProduct.monthlyTerm
    );
  const microdata = selectedProduct
    ? {
        sku: mirodataSkuIdentifier,
        productId: mirodataSkuIdentifier,
        url: window.location.href,
        name: selectedProduct.title,
        description: description,
        brand: data.phone.brand,
        color: selectedProduct.colour,
        price: payTodayValue,
        image:
          siteUrl +
          imageGallery[0]?.images[0]?.image?.childImageSharp?.fixed?.src,
        offers: {
          '@type': 'Offer',
          priceCurrency: 'SGD',
          price: payTodayValue,
          itemCondition: 'https://schema.org/NewCondition',
          availability: 'https://schema.org/InStock' // for out of stock use: “https://schema.org/OutOfStock”
        },
        additionalProperty: {
          '@type': 'PropertyValue',
          propertyID: selectedProduct.title,
          value: selectedProduct.title // phone title of the group
        }
      }
    : null;

  /**
   * Render SKU list in the DOM for a given segment, cis or residential.
   * This is to prevent hydration issues in react when cis skus differ
   * significantly from residential.
   * @return {JSX.Element}
   */
  const renderProductSelectionArea = (isCIS, variants) => {
    return (
      <div
        className={(isCIS ? 'cis-' : '') + 'product-selection-area'}
        style={{ display: 'none' }}
      >
        <div className={slug} key={slug}>
          <div className={colourClassName} />
          <div className={sizeClassName} />
          <div className={planNameClassName} />
          {monthlyTerm && <div className={monthlyTermClassName} />}
        </div>
        {variants.map(sku => {
          const { colour, size, planId, monthlyTerm } = sku;
          const plan = allPlan.find(node => node.mecId === planId);
          if (plan) {
            const url =
              (isCIS ? 'cis-' : '') +
              constructProductUrl(colour, size, plan.planName, monthlyTerm);
            return (
              <div key={url} className={url}>
                <div className={colourClassName}>{colour}</div>
                <div className={sizeClassName}>{size}</div>
                <div className={planNameClassName}>{planId}</div>
                {monthlyTerm && (
                  <div className={monthlyTermClassName}>{monthlyTerm}</div>
                )}
              </div>
            );
          }
          return null;
        })}
      </div>
    );
  };

  const planSectionRef = useRef(0);

  useEffect(() => {
    const isChangePlan = location?.state?.isChangePlan;
    if (isChangePlan) {
      const executeScroll = () => planSectionRef.current.scrollIntoView();
      setTimeout(() => {
        executeScroll();
      }, 0);
    } else {
      window.onbeforeunload = function() {
        window.scrollTo(0, 0);
      };
    }
  }, [location?.state?.isChangePlan, planSectionRef]);

  return (
    <div className="fs-unmask">
      <SEO title={pageTitle} description={description} microdata={microdata} />
      {isMounted() && !cisPlanRates && (
        <Spacing top={-5} topMd={-9}>
          <CisPointOfEntry />
        </Spacing>
      )}
      <StyledGridBoundary>
        <Row>
          <Column sm={12} md={6}>
            <Spacing top={4} topMd={9}>
              <PhoneImages
                imageGallery={imageGallery}
                selectedColour={selectedColour}
              />
            </Spacing>
          </Column>
          <Column sm={12} md={6}>
            <Spacing top={6} topMd={9} bottom={6} bottomMd={8}>
              <PhoneDetails
                title={title}
                promotions={phonePromotions}
                freeGiftsByDevice={freeGiftsByDevice}
                freeGiftsBySku={freeGiftsBySku}
                freeGiftStockAvail={freeGiftStockAvail}
                sizes={renderSizes}
                description={description}
                shippingLiner={shippingLiner}
                errorMessage={stockErrorMsg}
                selectedColour={selectedColour}
                selectedSize={selectedSize}
                colours={renderColours}
                onColourChange={colour => setColour(colour.name)}
                onSizeChange={size => setSize(size.name)}
                selectedProduct={selectedProduct}
              />
            </Spacing>
            <div ref={planSectionRef}>
              <PersistStatusConsumer>
                <Fragment>
                  <Spacing bottom={2} bottomMd={2}>
                    <StyledRow middle="sm">
                      <Column sm={9}>
                        <Spacing bottomMd={1}>
                          <Text type="header">Choose your plan</Text>
                        </Spacing>
                      </Column>
                    </StyledRow>
                  </Spacing>
                  {tags && isTagged(tags, phoneTagsConfig['5g-speed'].tagName) && (
                    <Spacing css={{ display: 'none' }}>
                      <StyledRow middle="sm">
                        <Column sm={12}>
                          <Spacing
                            bottomMd={1}
                            topMd={1}
                            bottomSm={1}
                            topSm={1}
                          >
                            <Notification state="info">
                              Your selected device is 5G-ready.
                            </Notification>
                          </Spacing>
                        </Column>
                      </StyledRow>
                    </Spacing>
                  )}
                  {renderPlans.length !== 0 && (
                    <Fragment>
                      <PhoneDetailsPlanSelect
                        planGroups={renderPlanGroups}
                        selectedPlanGroupName={selectedPlanGroupName}
                        onChange={handlePlanGroupChange}
                      />
                      {isSimOnlyPlus && (
                        <Spacing bottom={6} bottomMd={8}>
                          <ExclusiveValidation.Content
                            button={
                              <Spacing
                                top={6}
                                topMd={8}
                                bottom={6}
                                bottomMd={9}
                              >
                                <Button onClick={hideExclusiveValidation}>
                                  OK, show plans
                                </Button>
                              </Spacing>
                            }
                            showButton={exclusiveValidation.show}
                            onClick={hideExclusiveValidation}
                          />
                        </Spacing>
                      )}
                      {(!exclusiveValidation.show || !isSimOnlyPlus) && (
                        <Fragment>
                          {renderMonths.length > 0 && (
                            <Spacing bottom={4.5} bottomMd={6.5}>
                              <PhoneMonthSelection
                                months={renderMonths}
                                onMonthChange={month => setMonth(month)}
                                selectedMonth={selectedMonth}
                              />
                            </Spacing>
                          )}
                          <Spacing bottom={6} bottomMd={8}>
                            <PlansList
                              defaultPlanId={defaultPlan.mecId}
                              plans={renderPlans}
                              sizes={renderSizesByProduct}
                              selectedPlanId={selectedPlanId}
                              selectedSize={selectedSize}
                              onPlanChange={plan =>
                                !disableSection && onPlanChange(plan)
                              }
                              onSizeChange={size => setSize(size.name)}
                              disabled={disableSection}
                            />
                          </Spacing>
                        </Fragment>
                      )}
                    </Fragment>
                  )}
                  <Section
                    disabled={disableSection}
                    data-testid={getSectionTestId(disableSection)}
                  >
                    {(!exclusiveValidation.show || !isSimOnlyPlus) && (
                      <Spacing bottomMd={9}>
                        <CartSummary
                          hasPricePlanPhoneMonthly={hasPlanPhoneMonthly}
                          showCartSummary={showCartSummary}
                          disableCartSummary={!selectedProduct}
                          payToday={payToday}
                          monthlySubscription={monthlySubscription}
                          monthlySubscriptionText={
                            hasPlanPhoneMonthly
                              ? `Plan + Product instalment`
                              : `Plan`
                          }
                          onContinueBtnClick={handleContinueButtonClick}
                        />
                      </Spacing>
                    )}
                  </Section>
                </Fragment>
              </PersistStatusConsumer>
            </div>
          </Column>
        </Row>
      </StyledGridBoundary>
      {showProductVideo && (
        <RowNoMargin center="sm">
          <ColumnNoPadding>
            <PhoneDetailsVideo
              title={`Introducing the ${title} experience with Singtel`}
              videoUrl={videoUrl}
            />
          </ColumnNoPadding>
        </RowNoMargin>
      )}
      <GridNoPadding>
        <RowNoMargin>
          <ColumnNoPadding>
            <PhoneDetailsInfo
              whatsInTheBox={whatsInTheBox}
              specifications={specifications}
            />
          </ColumnNoPadding>
        </RowNoMargin>
      </GridNoPadding>
      <TransactionDialog
        open={openModal}
        isGomoToSingtelEnabled={isGomoToSingtelEnabled}
        onClickGomoPortIn={handleGomoPortInClick}
        onClose={() => setOpenModal(false)}
        data-testid="transaction-selection"
      />
      {!isCIS && renderProductSelectionArea(false, skuVariants)}
      {isCIS && isMounted() && renderProductSelectionArea(true, skuVariants)}
    </div>
  );
};

OldPhoneDetails.defaultProps = {
  exclusiveValidation: {
    show: true
  },
  getAuthToken: noop,
  setSelectedProduct: noop,
  setSelectedPlan: noop,
  setUserSelection: noop,
  resetByKeys: noop
};

OldPhoneDetails.propTypes = {
  data: PropTypes.object,
  exclusiveValidation: PropTypes.shape({
    show: PropTypes.bool
  }),
  getAuthToken: PropTypes.func,
  sessionToken: PropTypes.string,
  setSelectedProduct: PropTypes.func,
  setSelectedPlan: PropTypes.func,
  selectedProduct: PropTypes.object,
  selectedPlan: PropTypes.object,
  productOrder: PropTypes.object,
  productOrderIsLoading: PropTypes.bool,
  resetByKeys: PropTypes.func,
  cisPlanRates: PropTypes.arrayOf(
    PropTypes.shape({
      planID: PropTypes.string,
      discountedPrice: PropTypes.string
    })
  )
};

const Section = styled.div`
  ${p =>
    p.disabled &&
    css`
      opacity: 0.25;
      pointer-events: none;
      user-select: none;
    `};

  transition: 0.25s all ease-in-out;
`;

const StyledGridBoundary = styled(props => <Grid {...props} />)`
  position: relative;
`;

const StyledRow = styled(props => <Row {...props} />)`
  transition: margin-bottom 0.3s;
`;

const ColumnNoPadding = styled(props => <Column {...props} />)`
  padding: 0;
`;

const GridNoPadding = styled(props => <Grid {...props} />)`
  padding: 0;
`;

const RowNoMargin = styled(props => <Row {...props} />)`
  margin: 0;
`;

/**
 * Create sku field for phone microdata
 * @param sku
 * @param planName
 * @param monthlyTerm
 * @return {string}
 */
function createMirodataSkuIdentifier(sku, planName, monthlyTerm) {
  const planNameWithoutSpaces = planName.replace(/[ ]/g, '');
  return [sku, slugify(planNameWithoutSpaces), monthlyTerm]
    .filter(Boolean)
    .join('_');
}
